if (!customElements.get('header-menu')) {
  class HeaderMenu extends HTMLElement {
    constructor() {
      super();
      this.searchInput = this.querySelector('predictive-search');
      this.exposedSearchInput = this.querySelector('[data-exposed-ps]');
      this.searchOverlay = this.querySelector('[data-search-overlay]');
      this.toggleSearch = this.querySelector('[data-search-button]');
      this.headerActions = this.querySelector('[data-header-actions]');
      this.useVariant = typeof useVariantMenu !== 'undefined' && useVariantMenu;
    }

    connectedCallback() {
      this.addDelegatedClickListeners();
      this.addKeydownListener()
    }

    addKeydownListener() {
      this.searchInput.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.closeSearch();
      });

      if (this.exposedSearchInput) {
        this.exposedSearchInput.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.closeSearch();
        });
      }
    }
    addDelegatedClickListeners() {
      this.addEventListener('mouseover', (e) => {
        if (e.target.closest('[data-desktop-nav-item]')) {
          this.querySelectorAll('[data-desktop-nav-item].active').forEach(x => x.classList.remove('active'));
          e.target.closest('[data-desktop-nav-item]').classList.add('active');
        }
        if (!e.target.closest('nav') || e.target.closest('[data-overlay]')) {
          this.querySelectorAll('[data-desktop-nav-item].active').forEach(x => x.classList.remove('active'));
        }
      });
      
      this.addEventListener('click', (e) => {
        const mobileDrawer = this.querySelector(`[data-mobile-drawer${ this.useVariant ? '-variant' : '' }]`),
              mobileInner = this.querySelectorAll('[data-inner-menu]'),
              searchArea = this.querySelector('[data-search-dropdown]');

        if(!e.target.closest('[data-search-dropdown]') && !e.target.closest('[data-action]') && (searchArea.classList.contains('open') || this.exposedSearchInput?.classList.contains('open'))) {
          this.closeSearch()
        }     

        const clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;

        const {
          action,
          submenu
        } = clickedElement.dataset;

        
        switch (action) {
          case 'dropdown':
            if (clickedElement.parentElement.classList.contains('active')) {
              clickedElement.parentElement.classList.remove('active');
              return;
            }
            this.querySelectorAll('[data-desktop-nav-item].active').forEach(x => x.classList.remove('active'));
            clickedElement.parentElement.classList.add('active');
          break;
          case 'toggle-menu':
            document.body.classList.toggle('overflow-hidden');
            clickedElement.classList.toggle('active')
            mobileDrawer.classList.toggle('-translate-x-full');
            mobileInner.forEach(panel => {
              panel.classList.remove('-translate-x-1/3', 'opacity-0');
            });
            this.querySelector(`.open[data-mobile-drawer-submenu${ this.useVariant ? '-variant' : '' }]`)?.classList.add('translate-x-full');
            break;
          case 'open-submenu':
            if (!submenu) return;
            this.querySelector(`[data-mobile-drawer-submenu${ this.useVariant ? '-variant' : '' }="${submenu}"]`)?.classList.remove('translate-x-full');
            this.querySelector(`[data-mobile-drawer-submenu${ this.useVariant ? '-variant' : '' }="${submenu}"]`)?.classList.add('open');
            mobileInner.forEach(panel => {
              panel.classList.add('-translate-x-1/3', 'opacity-0');
            });
            break;
          case 'close-submenu':
            if (!submenu) return;
            this.querySelector(`[data-mobile-drawer-submenu${ this.useVariant ? '-variant' : '' }="${submenu}"]`)?.classList.add('translate-x-full');
            this.querySelector(`[data-mobile-drawer-submenu${ this.useVariant ? '-variant' : '' }="${submenu}"]`)?.classList.remove('open');
            mobileDrawer.classList.remove('-translate-x-full');
            mobileInner.forEach(panel => {
              panel.classList.remove('-translate-x-1/3', 'opacity-0');
            });
            break;
          case 'open-search':
            this.openSeach();
            break
          case 'close-search':
            this.closeSearch()
            break
          case 'open-search-exposed-mobile':
            this.openExposedSearch();
            break
          default:
          break;
        }
      });

      this.querySelectorAll('[data-action="dropdown"]').forEach(el => {
        let menu = el.parentElement.querySelector('[data-overlay-sibling]');
        el.addEventListener('mouseenter', (e) => {
            menu.setAttribute('aria-expanded', 'true');
        });
        el.addEventListener('mouseleave', (e) => {
            menu.setAttribute('aria-expanded', 'false');
        });
        el.addEventListener('focus', (e) => {
          this.querySelectorAll('[data-overlay-sibling]').forEach(sub => { sub.setAttribute('aria-expanded', 'false')});
          menu.getAttribute('aria-expanded') == 'false' ? menu.setAttribute('aria-expanded', 'true') : menu.setAttribute('aria-expanded', 'false');
        })  
      }) 

    }
    openSeach() {
      document.body.classList.add('overflow-hidden');
      let results = this.querySelector('#predictive-search-results');
      this.toggleSearch.setAttribute('data-action', 'close-search')
      this.searchInput.classList.add('active', 'open');
      this.headerActions.classList.add('open');
      this.searchInput.querySelector('input[type=search]').focus();
      this.querySelector('header').classList.add('z-20','!h-full');
      this.searchOverlay.classList.add('opacity-50');
      if (window.innerWidth < 1024) {
        let headerWidth = this.querySelector('header').offsetWidth,
            cartWidth = this.querySelector('[data-cart-button]').offsetWidth,
            extraPadding = 40;
        this.searchInput.style.width = headerWidth - cartWidth - extraPadding + 'px'
      }
    }
    
    closeSearch() {
      if (this.exposedSearchInput) {
        let exposedResults = this.exposedSearchInput.querySelector('#predictive-search-results');

        if (exposedResults != undefined) { 
          exposedResults.style.display = 'none';
        } else {
          this.exposedSearchInput.querySelector('#suggested-search-results').style.display = 'none';
        };

        this.exposedSearchInput?.classList.remove('active', 'open');
        this.exposedSearchInput.querySelector('input[type=search]').value = '';
      }

      document.body.classList.remove('overflow-hidden');
      let results = this.querySelector('#predictive-search-results');
      if (results != undefined) results.style.display = 'none';
      this.toggleSearch.setAttribute('data-action', 'open-search')
      this.searchInput.classList.remove('active', 'open');
      this.headerActions.classList.remove('open');
      this.searchInput.querySelector('input[type=search]').value = ''; 
      this.querySelector('header').classList.remove('z-20');
      this.searchOverlay.classList.remove('opacity-50');
      setTimeout(() => {
        this.querySelector('header').classList.remove('!h-full');
      },500)
      if (window.innerWidth < 1024) {
        this.searchInput.removeAttribute('style')
      }
    }

    openExposedSearch() {
      document.body.classList.add('overflow-hidden');
      this.toggleSearch.setAttribute('data-action', 'close-search')
      this.exposedSearchInput.classList.add('active', 'open');
      this.exposedSearchInput.querySelector('input[type=search]').focus();
      this.querySelector('header').classList.add('z-20','!h-full');
      this.searchOverlay.classList.add('opacity-50');
    }
  }

  customElements.define('header-menu', HeaderMenu);
}